export default __webpack_public_path__ + "static/media/Bindings of Necrotic Dread.c6cbb5a3.jpg";